import { Injectable } from '@angular/core';
import { Database, query, ref, set, get, update, remove, push, objectVal, listVal, QueryConstraint, stateChanges, ListenEvent, goOnline, goOffline } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

  constructor(
    private fbDatabase: Database,
  ) {

  }

  async getSnapshot(path: string, ...queries: QueryConstraint[]) {
    const rf = ref(this.fbDatabase, path);
    const qr = query(rf, ...queries);
    const snap = await get(qr);
    return snap.val();
  }

  setRef(path: string, data: any) {
    const rf = ref(this.fbDatabase, path);
    return set(rf, data)
  }

  updateRef(path: string, data: any) {
    const rf = ref(this.fbDatabase, path);
    return update(rf, data)
  }

  removeRef(path: string) {
    const rf = ref(this.fbDatabase, path);
    return remove(rf)
  }

  getObjectByRef<T>(path: string, key: string, ...queries: QueryConstraint[]) {
    const rf = ref(this.fbDatabase, path);
    const qr = query(rf, ...queries);
    return objectVal<T>(qr, {
      keyField: key
    });
  }

  getListByRef<T>(path: string, key: string, ...queries: QueryConstraint[]) {
    const rf = ref(this.fbDatabase, path);
    const qr = query(rf, ...queries);
    return listVal<T>(qr, {
      keyField: key
    });
  }

  getListByRefTest<T>(path: string, ...queries: QueryConstraint[]) {
    const rf = ref(this.fbDatabase, path);
    const qr = query(rf, ...queries);
    return objectVal<T>(qr);
  }

  getStateChangesByRef<T>(path: string, events: ListenEvent[], ...queries: QueryConstraint[]) {
    const rf = ref(this.fbDatabase, path);
    const qr = query(rf, ...queries);
    return stateChanges(qr, {
      events: events
    });
  }

  pushByRef(path: string, data: any) {
    const rf = ref(this.fbDatabase, path);
    return push(rf, data)
  }

  goOnline() {
    goOnline(this.fbDatabase);
  }

  goOffline() {
    goOffline(this.fbDatabase);
  }
}